/**
 * Gedeelde regels voor links naar de DPI-checker. De productpagina geeft het
 * gekozen formaat (mm) en de productslug mee; de checker leest ze hier weer
 * terug. Alles wat niet klopt wordt genegeerd, zodat de checker nooit een
 * willekeurige URL of een onzinmaat toont.
 */
export const DPI_CHECKER_PATH = '/tools/dpi-checker';
export const DPI_CHECKER_PROMO_ID = 'dpi_checker';

const MIN_MM = 10;
const MAX_MM = 10000;
const SLUG = /^[a-z0-9][a-z0-9-]{0,119}$/;

export type DpiCheckerTarget = { widthMm: number; heightMm: number };

function readMm(value: unknown): number | null {
  const raw = Array.isArray(value) ? value[0] : value;
  if (typeof raw !== 'string' || !/^\d{1,5}$/.test(raw)) return null;
  const mm = Number(raw);
  return mm >= MIN_MM && mm <= MAX_MM ? mm : null;
}

export function readDpiCheckerTarget(params: Record<string, unknown> | undefined): DpiCheckerTarget | null {
  const widthMm = readMm(params?.w);
  const heightMm = readMm(params?.h);
  return widthMm && heightMm ? { widthMm, heightMm } : null;
}

export function readDpiCheckerProductSlug(params: Record<string, unknown> | undefined): string | null {
  const raw = Array.isArray(params?.product) ? params?.product[0] : params?.product;
  return typeof raw === 'string' && SLUG.test(raw) ? raw : null;
}

/** Pad zonder taalprefix, voor de i18n-Link of met `/${locale}` ervoor. */
export function dpiCheckerHref(options: { widthMm?: number | null; heightMm?: number | null; productSlug?: string | null } = {}): string {
  const params = new URLSearchParams();
  const w = Math.round(Number(options.widthMm));
  const h = Math.round(Number(options.heightMm));
  if (w >= MIN_MM && w <= MAX_MM && h >= MIN_MM && h <= MAX_MM) {
    params.set('w', String(w));
    params.set('h', String(h));
  }
  if (options.productSlug && SLUG.test(options.productSlug)) params.set('product', options.productSlug);
  const query = params.toString();
  return query ? `${DPI_CHECKER_PATH}?${query}` : DPI_CHECKER_PATH;
}
